import { GNS } from '../core/GNS.js';

/**
 * GNS.PageLoading
 * 
 * ページ遷移時のローディング画面を管理
 * 
 * 主要メソッド:
 * - show(): ローディング表示
 * - hide(): ローディング非表示
 */
GNS.PageLoading = function (a) {
    var b, c = a.create(a.AbstractElementView);
    return c._static.getInstance = function () {
        return b || (b = new c._self), b
    }, c.init = function () {
        c._super.init.apply(this, ["page_loading"])
    }, c.show = function () {
        c._super.show.call(this)
    }, c.hide = function () {
        c._super.hide.call(this)
    }, c._self
}(GNS);
